// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sitf","input":"styles_input__2YvIk"};